module.exports = __webpack_public_path__ + "img/mne.76c434a6.svg";